var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lot-container"},_vm._l((_vm.content),function(lot){return _c('lot-thumbnail',{key:lot.id,staticClass:"lot-thumbnail",attrs:{"lotInfo":lot,"componentActive":_vm.componentActive}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }